import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Filter, Sliders } from 'feather-icons-react/build/IconComponents';
import { ImageWithBasePath } from 'Core/components';
import Select from 'react-select';
import { actions as inventoryActions } from './store/slice';
import { selectInventoryFilterVisible } from './store/selectors';

const { setDetailSearchText } = inventoryActions;

const InventoryDetailSearch = () => {
  const dispatch = useDispatch();
  const filterVisible = useSelector(selectInventoryFilterVisible);
  const [searchText, setSearchTextValue] = useState('');

  const handleSearch = e => {
    const newSearchText = e.target.value;
    setSearchTextValue(newSearchText);
    dispatch(setDetailSearchText(newSearchText));
  };

  const oldandlatestvalue = [
    { value: 'date', label: 'Sort by Date' },
    { value: 'newest', label: 'Newest' },
    { value: 'oldest', label: 'Oldest' },
  ];

  return (
    <>
      <div className="search-set">
        <div className="search-input">
          <Link to="#" className="btn btn-searchset">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-search"
            >
              <circle cx={11} cy={11} r={8} />
              <line x1={21} y1={21} x2="16.65" y2="16.65" />
            </svg>
          </Link>
          <div id="DataTables_Table_0_filter" className="dataTables_filter">
            <label>
              {' '}
              <input
                type="search"
                className="form-control form-control-sm"
                placeholder="Search"
                aria-controls="DataTables_Table_0"
                value={searchText}
                onChange={handleSearch}
              />
            </label>
          </div>
        </div>
      </div>
      
    </>
  );
};

export default InventoryDetailSearch;
